var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPerakendeB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 61,
    viewBox: "0 0 65 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 12.6798H37.9166V7.60778C37.9166 6.93519 37.6312 6.29015 37.1233 5.81456C36.6154 5.33896 35.9265 5.07178 35.2083 5.07178H29.7916C29.0733 5.07178 28.3844 5.33896 27.8765 5.81456C27.3686 6.29015 27.0833 6.93519 27.0833 7.60778V12.6798Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9166 8.87598C37.9166 12.9995 39.2897 17.0216 41.8437 20.3818L41.9791 20.5593C44.6219 24.0354 46.0419 28.1964 46.0416 32.4634V48.184C46.0416 49.5292 45.4709 50.8193 44.4551 51.7705C43.4393 52.7217 42.0615 53.2561 40.6249 53.2561H24.3749C22.9383 53.2561 21.5606 52.7217 20.5448 51.7705C19.5289 50.8193 18.9583 49.5292 18.9583 48.184V32.4608C18.9583 28.1953 20.3774 24.0362 23.0208 20.5593L23.1562 20.3818C25.7106 17.022 27.0833 13.0002 27.0833 8.87598",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 37.5401C20.0416 37.1039 20.9778 36.3999 21.6666 35.5036C22.2818 34.701 23.0965 34.0507 24.0402 33.6089C24.984 33.167 26.0284 32.947 27.0833 32.9676C28.1381 32.947 29.1825 33.167 30.1263 33.6089C31.07 34.0507 31.8847 34.701 32.4999 35.5036C33.1152 36.3063 33.9298 36.9566 34.8736 37.3984C35.8173 37.8403 36.8617 38.0603 37.9166 38.0397C38.9715 38.0603 40.0159 37.8403 40.9596 37.3984C41.9033 36.9566 42.718 36.3063 43.3333 35.5036C44.0213 34.6055 44.9576 33.8998 46.0416 33.4622",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerakendeB);
export default __webpack_public_path__ + "static/media/perakende_b.0f261fcaa87f60adfbd16eacaad2210e.svg";
export { ForwardRef as ReactComponent };